import React, { useEffect, useState } from 'react';
import { PrematchContext } from '../Prematch';
import { BreadcrumbContext } from './BreadcrumbContext';
import TournamentLink from './TournamentLink';

function TournamentBreadcrumb(props) {
    const prematchContext = React.useContext(PrematchContext);
    const breadcrumbContext = React.useContext(BreadcrumbContext);
    const [dropdownToggled, setDropdownToggled] = useState(false);

    function toggleDropdown() {
        if (dropdownToggled) {
            setDropdownToggled(false);
        } else {
            breadcrumbContext.setType('tournament');
        }
    }

    useEffect(() => {
        if (breadcrumbContext && breadcrumbContext.type) {
            if (breadcrumbContext.type === 'tournament' && !dropdownToggled) {
                setDropdownToggled(true);
            } else if (dropdownToggled) {
                setDropdownToggled(false);
            }
        }
    }, [breadcrumbContext]);

    let tournaments = prematchContext.applyTemporalFilter(props.tournaments);
    // If the tournament has been opened from the favorites section, only show favorite tournaments in the breadcrumb menu
    if (prematchContext.openedFromFavorites) {
        const favorites = Object.keys(prematchContext.favoriteTournaments);
        const filtered = [];
        tournaments.forEach(t => favorites.includes(t.uniqueId) && filtered.push(t));
        if (filtered.length > 0) {
            tournaments = filtered;
        }
    }

    return (
        <span className="nav-breadcrumb" onClick={toggleDropdown}>
            <span className="nav-breadcrumb-label" >{props.desc}</span>
            {dropdownToggled &&
                <div className="nav-dropdown">
                    {tournaments.map(t => {
                        function handleClick() {
                            prematchContext.openTournament(t.uniqueId);
                        }
                        const selected = t.id === props.selected;
                        return (
                           /*  <div key={t.id} className={"event-desc text-small" + classIf(selected, 'selected')} onClick={handleClick}>
                                <span>{t.descrizione}</span>
                            </div> */
                            <TournamentLink key={t.id} {...t} selected={selected} onClick={handleClick} />
                        )
                    })}
                </div>
            }
        </span>
    );
}

export default TournamentBreadcrumb;